// extracted by mini-css-extract-plugin
export default {"container":"style_container__ePDMR","content":"style_content__EOL2y","content_title":"style_content_title__d2B-Y","content_description":"style_content_description__vtR0i"};